export enum LabelType {
  WHITE = 'white',
  BLACK = 'black',
  SIMPLE = 'simple',
  NONE = 'none',
}
